import { TFunction } from "react-i18next";

export type Translate = TFunction<"translation", undefined>;

export type ValidateCSVError = string;
export type ValidateCSVErrors = Array<ValidateCSVError>;
export type ValidateCSVLine = string;
export interface ValidateCSVFieldErrors {
  [line: ValidateCSVLine]: ValidateCSVErrors;
}
export interface ValidateCSVGeneralErrors {
  [key: string]: string;
}

const getMustBeFilledMessageError = (columnName: string, translate: Translate) =>
  `${columnName} ${translate("columnMustBeFilled")}`;

const getNotFoundMessageError = (columnName: string, value: string, translate: Translate) =>
  `${columnName} ${value} ${translate("notFound")}`;

const getNotValidMessageError = (columnName: string, value: string, translate: Translate) =>
  `${columnName} (${value}) ${translate("isNotValid")}`;

const changeLineError = (
  lineErrors: ValidateCSVFieldErrors,
  line: number,
  messageError: ValidateCSVError
) => {
  if (lineErrors[line]) {
    lineErrors[line] = [...lineErrors[line], messageError];
  } else {
    lineErrors[line] = [messageError];
  }
};

export const messages = (translate: Translate) => {
  return {
    filled: (columnName: string) => getMustBeFilledMessageError(columnName, translate),
    notfound: (columnName: string, value: string) =>
      getNotFoundMessageError(columnName, value, translate),
    invalid: (columnName: string, value: string) =>
      getNotValidMessageError(columnName, value, translate),
  };
};

export const addErrorInLine = (
  lineErrors: ValidateCSVFieldErrors,
  line: number,
  messageError: ValidateCSVError,
  callback?: () => void
) => {
  changeLineError(lineErrors, line, messageError);
  if (callback) callback();
};
